<template>
  <v-footer app absolute color="secondary" min-height="128" :height="footerHeight" class="py-6 d-print-none">
    <v-container class="container--max">
      <v-row align="center" justify="end">

        <!-- logo -->
        <v-col cols="12" md="2" class="text-center">
          <a href="/">
            <v-img :src="logo" height="32" width="160" contain class="mx-auto mb-6 mb-md-0"></v-img>
          </a>
        </v-col>

        <!-- news -->
        <v-col cols="12" sm="3" md="2" offset-md="1">
          <v-list dark dense class="transparent text--upper ch-list--footer">
<!--             <v-list-item>
              <v-list-item-content>
                <v-list-item-title>News</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item v-for="(item, i) in listOne" :key="'a'+i" :href="item.link">
              <v-list-item-content>
                <v-list-item-subtitle v-html="item.text"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-list dark dense class="transparent text--upper ch-list--footer">
<!--             <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Politics</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item v-for="(item, i) in listTwo" :key="'b'+i" :href="item.link">
              <v-list-item-content>
                <v-list-item-subtitle v-html="item.text"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-list dark dense class="transparent text--upper ch-list--footer">
<!--             <v-list-item>
              <v-list-item-content>
                <v-list-item-title>About</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item v-for="(item, i) in listThree" :key="'c'+i" :href="item.link">
              <v-list-item-content>
                <v-list-item-subtitle v-html="item.text"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-list dark dense class="transparent text--upper ch-list--footer">
<!--             <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Useful Info</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item v-for="(item, i) in listFour" :key="'d'+i" :href="item.link">
              <v-list-item-content>
                <v-list-item-subtitle v-html="item.text"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        
        <!-- social icons -->
        <v-col cols="12" md="1">
          <div class="d-flex d-md-none justify-center Xjustify-space-around">
            <v-btn href="https://www.facebook.com/ConservativeHome" target="_blank" rel="noopener" small icon color="accent" class="mx-2">
              <v-icon small>mdi-facebook</v-icon>
            </v-btn>
            <v-btn href="https://twitter.com/ConHome" target="_blank" rel="noopener" small icon color="accent" class="mx-2">
              <v-icon small>mdi-twitter</v-icon>
            </v-btn>
            <v-btn href="https://www.youtube.com/channel/UCbxXu42P7hiExin_nfG5XQw" target="_blank" rel="noopener" small icon color="accent" class="mx-2">
              <v-icon small>mdi-youtube</v-icon>
            </v-btn>
            <v-btn href="https://podcasts.apple.com/gb/podcast/the-moggcast/id1335312124" target="_blank" rel="noopener" small icon color="accent" class="mx-2">
              <v-icon small>mdi-podcast</v-icon>
            </v-btn>
          </div>
          <div class="d-none d-md-flex flex-column align-center">
            <v-btn href="https://www.facebook.com/ConservativeHome" target="_blank" rel="noopener" small icon color="accent" class="mb-1">
              <v-icon small>mdi-facebook</v-icon>
            </v-btn>
            <v-btn href="https://twitter.com/ConHome" target="_blank" rel="noopener" small icon color="accent" class="mb-1">
              <v-icon small>mdi-twitter</v-icon>
            </v-btn>
            <v-btn href="https://www.youtube.com/channel/UCbxXu42P7hiExin_nfG5XQw" target="_blank" rel="noopener" small icon color="accent" class="mb-1">
              <v-icon small>mdi-youtube</v-icon>
            </v-btn>
            <v-btn href="https://podcasts.apple.com/gb/podcast/the-moggcast/id1335312124" target="_blank" rel="noopener" small icon color="accent" class="mb-1">
              <v-icon small>mdi-podcast</v-icon>
            </v-btn>
          </div>
        </v-col>

      </v-row>
    </v-container>
    <!-- footer overlay -->
    <v-bottom-sheet
      eager
      hide-overlay
      inset
      no-click-animation
      persistent
      ref="adSheet"
      v-model="isScrolled"
      width="100%"
      content-class="v-footer--sticky-ad"
      v-if="!noAds"
    >
      <v-card tile color="transparent" class="d-flex" flat>
        <div class="d-flex text-center align-center justify-center mx-auto sticky-ad__wrapper">
          <slot name="ad-footer"></slot>
        </div>
        <div class="d-flex align-center justify-end" style="margin-left: -52px;">
          <v-btn small text icon class="ma-3 white" color="blue-grey darken-4" @click="sheet = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-bottom-sheet>
  </v-footer>
</template>

<script>
  export default {
    name: 'AppFooter',

    props: {
      noAds: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      finalLogo:  require('@/assets/conhome-logo-white-final.svg'),
      fullLogo: require('@/assets/conhome-full-logo-dark.svg'),
      // houseLogo: require('@/assets/conhome-house-logo-dark.svg'),
      listOne: [
        { text: 'Home', link: '/' },
        { text: 'About', link: '/about' },
        { text: 'Contribute', link: '/contribute' },
        { text: 'Audio', link: '/audio' },
        { text: 'Video', link: '/video' },
        // { text: 'ToryDiary', link: '/torydiary' },
        // { text: 'Comment', link: '/comment' },
        // { text: 'Columnists', link: '/columnists' },
      ],
      listTwo: [
        { text: 'ToryDiary', link: '/torydiary' },
        { text: 'Comment', link: '/comment' },
        { text: 'Columnists', link: '/columnists' },
        { text: 'Parliament', link: '/parliament' },
        { text: 'Local Government', link: '/local-government' },
        // { text: 'Audio', link: '/audio' },
        // { text: 'Video', link: '/video' },
      ],
      listThree: [
        { text: 'Events', link: '/events' },
        // { text: 'About', link: '/about' },
        { text: 'Advertising', link: '/advertising' },
        // { text: 'Contribute', link: '/contribute' },
        // { text: 'Contact', link: '/contact' },
        { text: 'Commercial Partnerships', link: '/commercial-partnerships' },
        { text: 'Event Sponsorship', link: '/event-sponsorship' },
        { text: 'Survey Panel', link: '/survey-panel' },
      ],
      listFour: [
        { text: 'Contact', link: '/contact' },
        { text: 'Privacy', link: '/privacy-policy' },
        { text: 'Cookies', link: '/cookie-policy' },
        { text: 'Terms', link: '/terms-and-conditions' },
        { text: 'Comments Policy', link: '/comments-policy' },
      ],
      // this is necessary to avoid overlap
      heights: {
        xs: 990,
        sm: 420,
        md: 300
      },
      scrolled: false,
      sheet: true,
      canOpen: false
    }),

    computed: {
      footerHeight() {
        if (this.$vuetify.breakpoint.xs) {
          return 956 //844
        }
        if (this.$vuetify.breakpoint.sm) {
          return 356 //344
        }
        if (this.$vuetify.breakpoint.mdAndUp) {
          return 224 //206
        }
        return 'auto';
      },
      logo() {
        return this.finalLogo
      },
      isScrolled() {
        return this.sheet && this.scrolled
      }
    },

    methods: {
      handleScroll () {
        this.scrolled = window.scrollY > 360
      }
    },

    watch: {
      isScrolled() {
        this.$nextTick(() => {
          this.$refs.adSheet.showScroll()
          // either set :retain-focus="false" above or do this:
          this.$nextTick(() => this.$refs.adSheet.unbind())
        });
      }
    },

    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }
</script>

<style lang="sass">
.ch-list--footer
  &.v-list-item--dense,
  &.v-list--dense .v-list-item
    min-height: 32px
    font-size: 0.75rem

.v-footer--sticky-ad
  box-shadow: none
  -webkit-box-shadow: none
</style>